// ELO 로직
(function () {
    var TEST_COOKIE_PREFIX = "ab_test_result_";
    var SESSION_KEY = "ab_test_entry_info";
    var TRACKING_INFO_KEY = "ab_test_tracking_info";
    var PA_SENT_PREFIX = "ab_test_pa_sent_";
    var isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    var isPC = !isMobile;
    var eloEventNum = isPC ? 1 : 2;
    var hasOwn = Object.prototype.hasOwnProperty;

    function hasOwnProp(obj, key) {
        return hasOwn.call(obj, key);
    }

    function startsWith(str, prefix) {
        return String(str).indexOf(prefix) === 0;
    }

    function includes(str, search) {
        return String(str).indexOf(search) !== -1;
    }

    function objectEntries(obj) {
        var out = [];
        var key;
        for (key in obj) {
            if (hasOwnProp(obj, key)) out.push([key, obj[key]]);
        }
        return out;
    }

    function objectValues(obj) {
        var out = [];
        var key;
        for (key in obj) {
            if (hasOwnProp(obj, key)) out.push(obj[key]);
        }
        return out;
    }

    function cloneObject(obj) {
        var out = {};
        var key;
        if (!obj || typeof obj !== "object") return out;
        for (key in obj) {
            if (hasOwnProp(obj, key)) out[key] = obj[key];
        }
        return out;
    }

    function getSortedParamPairs(params) {
        var seen = {};
        var keys = [];
        var pairs = [];
        var i;
        var j;
        var key;
        var values;

        params.forEach(function (_, currentKey) {
            currentKey = String(currentKey);
            if (!hasOwnProp(seen, currentKey)) {
                seen[currentKey] = true;
                keys.push(currentKey);
            }
        });

        keys.sort();
        for (i = 0; i < keys.length; i++) {
            key = keys[i];
            values = params.getAll(key).map(String).sort();
            for (j = 0; j < values.length; j++) {
                pairs.push([key, values[j]]);
            }
        }

        return pairs;
    }

    function getOriginEntryUrl(entry) {
        return entry && (entry.url || entry.href || entry.link || entry.originUrl);
    }

    function getAlternateEntryUrl(entry) {
        return entry && (entry.url || entry.href || entry.link || entry.to || entry.destination);
    }

    function deleteCookie(name) {
        document.cookie = name + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    }

    function getUTMParams() {
        var params = new URLSearchParams(window.location.search);
        var utm = {};
        params.forEach(function (value, key) {
            key = String(key).toLowerCase();
            if (startsWith(key, "utm_")) utm[key] = value;
        });
        return utm;
    }

    function getCurrentParams() {
        var params = new URLSearchParams(window.location.search);
        var out = {};
        params.forEach(function (value, key) {
            out[String(key).toLowerCase()] = value;
        });
        return out;
    }

    function buildURLWithQueryConditions(baseUrl, queryConditions) {
        var conditions = Array.isArray(queryConditions) ? queryConditions : [];
        var i;
        var cond;
        var key;
        var value;
        try {
            var u = new URL(baseUrl, location.origin);
            for (i = 0; i < conditions.length; i++) {
                cond = conditions[i] || {};
                key = cond.key;
                value = cond.value;
                if (!key || typeof value === "undefined" || value === null) continue;
                u.searchParams.set(String(key), String(value));
            }
            return u.toString();
        } catch (e) {
            return baseUrl;
        }
    }

    function saveSessionEntry() {
        if (!sessionStorage.getItem(SESSION_KEY)) {
            sessionStorage.setItem(
                SESSION_KEY,
                JSON.stringify({ url: window.location.href, utm: getUTMParams() })
            );
        }
    }

    function getCookie(name) {
        var match = document.cookie.match(new RegExp(name + "=([^;]+)"));
        return match ? decodeURIComponent(match[1]) : null;
    }

    function setCookie(name, value, expires) {
        document.cookie =
            name +
            "=" +
            encodeURIComponent(value) +
            "; path=/; expires=" +
            expires.toUTCString();
    }

    function getPageKeyFromURL(url, options) {
        var stripTracking;
        var u;
        var host;
        var path;
        var raw;
        var usp;
        var pairs;
        var filtered;
        var queryParts;
        var query;
        var i;
        var pair;
        var TRACKING_RE =
            /^(utm_|gclid$|fbclid$|msclkid$|ttclid$|igshid$|_ga$|wbraid$|gbraid$|yclid$|dclid$|twclid$|utm_id$|cafe_mkt$|mkt_in$|ghost_mall_id$|ref$|NaPm$|NaPt$|NaPp$|NaPa$|n_media$|n_query$|n_rank$|n_ad_group_type$|acode$|scode$|app4$|g_adid$|media$|p_code$|skey$|campaign_id$|adgroup_id$|ad_keyword$|shopbytracking$|shopby_ref$|shopby_event$|k_medium$|k_campaign$|k_content$|k_keyword$|ad_id$|click_id$|fb_action_ids$|fb_action_types$|fb_source$)/i;

        options = options || {};
        stripTracking = typeof options.stripTracking === "undefined" ? true : options.stripTracking;

        try {
            u = new URL(url, location.origin);
            host = u.hostname.toLowerCase();
            host = host.replace(/^(www\.|m\.|mobile\.|amp\.)/, "");

            path = u.pathname.replace(/\/{2,}/g, "/");
            if (path.length > 1) path = path.replace(/\/+$/, "");

            raw = startsWith(u.search, "?") ? u.search.slice(1) : u.search;
            usp = new URLSearchParams(raw);
            pairs = getSortedParamPairs(usp);
            filtered = [];

            if (stripTracking) {
                for (i = 0; i < pairs.length; i++) {
                    pair = pairs[i];
                    if (!TRACKING_RE.test(pair[0])) filtered.push(pair);
                }
            } else {
                filtered = pairs;
            }

            queryParts = [];
            for (i = 0; i < filtered.length; i++) {
                pair = filtered[i];
                queryParts.push(encodeURIComponent(pair[0]) + "=" + encodeURIComponent(pair[1]));
            }

            query = queryParts.join("&");
            return query ? host + path + "?" + query : host + path;
        } catch (e) {
            return null;
        }
    }

    function isIncludedURL(sourceUrl, targetUrl, options) {
        var sourceKey = getPageKeyFromURL(sourceUrl, options);
        var targetKey = getPageKeyFromURL(targetUrl, options);
        if (!sourceKey || !targetKey) return false;
        return includes(sourceKey, targetKey) || includes(targetKey, sourceKey);
    }

    function getComparableURLInfo(url) {
        try {
            var u = new URL(url, location.origin);
            var host = u.hostname.toLowerCase().replace(/^(www\.|m\.|mobile\.|amp\.)/, "");
            var path = u.pathname.replace(/\/{2,}/g, "/");
            var params;
            var pairs;

            if (path.length > 1) path = path.replace(/\/+$/, "");
            params = new URLSearchParams(u.search);
            pairs = getSortedParamPairs(params);
            return { host: host, path: path, pairs: pairs };
        } catch (e) {
            return null;
        }
    }

    function isSamePageURL(sourceUrl, targetUrl) {
        var source = getComparableURLInfo(sourceUrl);
        var target = getComparableURLInfo(targetUrl);
        var i;
        var j;
        var targetPair;
        var sourcePair;
        var found;

        if (!source || !target) return false;
        if (source.host !== target.host || source.path !== target.path) return false;

        for (i = 0; i < target.pairs.length; i++) {
            targetPair = target.pairs[i];
            found = false;
            for (j = 0; j < source.pairs.length; j++) {
                sourcePair = source.pairs[j];
                if (sourcePair[0] === targetPair[0] && sourcePair[1] === targetPair[1]) {
                    found = true;
                    break;
                }
            }
            if (!found) return false;
        }

        return true;
    }

    function getTestOriginURL(test) {
        var originUrl = test && test.origin ? test.origin.url || "" : "";
        var queryConditions = test ? test.queryConditions : undefined;
        return buildURLWithQueryConditions(originUrl, queryConditions);
    }

    function isSameOrSubsetURL(sourceUrl, targetUrl) {
        return isSamePageURL(sourceUrl, targetUrl) || isSamePageURL(targetUrl, sourceUrl);
    }

    function determineGroupName(url, test) {
        var originUrl = getTestOriginURL(test);
        var alternates = test && test.alternates ? test.alternates : [];
        var i;
        var altUrl;

        if (url && originUrl && isSameOrSubsetURL(url, originUrl)) return "원본";
        for (i = 0; i < alternates.length; i++) {
            altUrl = alternates[i] ? alternates[i].url : undefined;
            if (altUrl && url && isSameOrSubsetURL(url, altUrl)) return "대안" + (i + 1);
        }
        return "unknown";
    }

    function isLegacyBaseOriginURL(url, test) {
        var rawOriginUrl = test && test.origin ? test.origin.url : undefined;
        var resolvedOriginUrl = getTestOriginURL(test);
        var rawOriginKey;
        var resolvedOriginKey;
        var currentKey;

        if (!url || !rawOriginUrl || !resolvedOriginUrl) return false;

        rawOriginKey = getPageKeyFromURL(rawOriginUrl, { stripTracking: false });
        resolvedOriginKey = getPageKeyFromURL(resolvedOriginUrl, { stripTracking: false });
        currentKey = getPageKeyFromURL(url, { stripTracking: false });

        if (!rawOriginKey || !resolvedOriginKey || !currentKey) return false;
        if (rawOriginKey === resolvedOriginKey) return false;

        return currentKey === rawOriginKey;
    }

    function normalizeABInfoForTest(abInfo, test) {
        var normalized;
        var originUrl;
        var group;

        if (!abInfo || !test) return abInfo;

        normalized = cloneObject(abInfo);
        originUrl = getTestOriginURL(test);

        if (isLegacyBaseOriginURL(normalized.url, test) && originUrl) {
            normalized.url = originUrl;
        }

        group = determineGroupName(normalized.url, test);
        if (group !== "unknown") normalized.group = group;
        if (normalized.group === "원본" && originUrl) normalized.url = originUrl;

        return normalized;
    }

    function weightedRandom(variants) {
        var total = 0;
        var i;
        var weight;
        var r;
        var acc = 0;

        for (i = 0; i < variants.length; i++) {
            total += Number((variants[i] && variants[i].weight) || 0);
        }
        if (total <= 0) return variants[0];

        r = Math.random() * total;
        for (i = 0; i < variants.length; i++) {
            weight = Number((variants[i] && variants[i].weight) || 0);
            acc += weight;
            if (r < acc) return variants[i];
        }

        return variants[variants.length - 1];
    }

    function toISODate(val) {
        var d;
        var ms;
        if (val == null) return null;
        if (typeof val === "number") {
            ms = val < 1e12 ? val * 1000 : val;
            return new Date(ms).toISOString();
        }
        d = new Date(val);
        return isNaN(d.getTime()) ? null : d.toISOString();
    }

    function pick() {
        var i;
        for (i = 0; i < arguments.length; i++) {
            if (arguments[i] !== undefined && arguments[i] !== null) return arguments[i];
        }
        return undefined;
    }

    function toArray(value) {
        if (Array.isArray(value)) return value;
        if (value === undefined || value === null || value === "") return [];
        return [value];
    }

    function normalizeOriginEntries() {
        var flattened = [];
        var out = [];
        var i;
        var j;
        var list;
        var entry;
        var url;

        for (i = 0; i < arguments.length; i++) {
            list = toArray(arguments[i]);
            for (j = 0; j < list.length; j++) flattened.push(list[j]);
        }

        for (i = 0; i < flattened.length; i++) {
            entry = flattened[i];
            if (typeof entry === "string") {
                out.push({ url: entry, weight: 1 });
                continue;
            }
            url = getOriginEntryUrl(entry);
            if (!url) continue;
            out.push({
                url: url,
                weight: Number(pick(entry.weight, 1)) || 1,
            });
        }

        return out;
    }

    function matchesUTMConditions(item) {
        var currentUTM;
        var effectiveUTM;
        var sets;
        var i;

        function matchesUTMValue(utmVal, conditionVal) {
            if (typeof utmVal === "undefined" || conditionVal === null) return false;
            return includes(String(utmVal), String(conditionVal));
        }

        function passesSet(set) {
            var includeOK = true;
            var excludeHit = false;
            var i;
            var cond;
            var key;
            var val;
            var utmVal;

            for (i = 0; i < set.length; i++) {
                cond = set[i] || {};
                key = cond.utmKey ? String(cond.utmKey).toLowerCase() : undefined;
                val = cond.utmValue;
                if (!key || typeof val === "undefined") continue;
                utmVal = effectiveUTM[key];
                if (cond.isIncluded) includeOK = includeOK && matchesUTMValue(utmVal, val);
                else if (matchesUTMValue(utmVal, val)) excludeHit = true;
                if (!includeOK || excludeHit) break;
            }

            return includeOK && !excludeHit;
        }

        if (!item || !item.useCondition) return true;

        currentUTM = getUTMParams();
        effectiveUTM = Object.keys(currentUTM).length > 0 ? currentUTM : {};
        if (Array.isArray(item.conditions) && Array.isArray(item.conditions[0])) {
            sets = item.conditions;
        } else {
            sets = [item.conditions || []];
        }

        for (i = 0; i < sets.length; i++) {
            if (passesSet(sets[i])) return true;
        }
        return false;
    }

    function matchesQueryConditions(item) {
        var queryConditions = Array.isArray(item && item.queryConditions)
            ? item.queryConditions
            : [];
        var currentParams;
        var i;
        var cond;
        var key;
        var val;

        if (queryConditions.length === 0) return true;

        currentParams = getCurrentParams();
        for (i = 0; i < queryConditions.length; i++) {
            cond = queryConditions[i] || {};
            key = cond.key ? String(cond.key).toLowerCase() : undefined;
            val = cond.value;
            if (!key || typeof val === "undefined") continue;
            if (currentParams[key] !== String(val)) return false;
        }
        return true;
    }

    function isActiveNow(item, now) {
        var start;
        var end;
        if (typeof now === "undefined") now = new Date();
        start = new Date(item.startTime);
        end = new Date(item.endTime);
        return now >= start && now <= end;
    }

    // === 새 스키마 정규화: { [originUrl]: { abtests: [...], redirects: [...] } } ===
    function normalizeByOrigin(raw0) {
        var raw = raw0 && raw0.landings;
        var out = {};
        var entries = [];
        var rawEntries;
        var i;
        var j;
        var k;
        var item;
        var payload;
        var itemOrigins;
        var abArr;
        var redArr;
        var abtests;
        var redirects;
        var t;
        var r;
        var id;
        var name;
        var startTime;
        var endTime;
        var origins;
        var variants;
        var rawVariants;
        var origin;
        var originKey;
        var redirect;

        function getArrayCI(obj) {
            var table = {};
            var entries;
            var i;
            var key;
            var value;

            if (!obj || typeof obj !== "object") return [];
            entries = objectEntries(obj);
            for (i = 0; i < entries.length; i++) {
                key = String(entries[i][0]).toLowerCase();
                value = entries[i][1];
                table[key] = value;
            }
            for (i = 1; i < arguments.length; i++) {
                value = table[String(arguments[i]).toLowerCase()];
                if (Array.isArray(value)) return value;
            }
            return [];
        }

        if (raw == null) raw = raw0 && raw0.data;
        if (raw == null) raw = raw0;
        if (!raw || typeof raw !== "object") return out;

        if (Array.isArray(raw)) {
            entries = raw;
        } else {
            rawEntries = objectEntries(raw);
            for (i = 0; i < rawEntries.length; i++) {
                entries.push({ origin: rawEntries[i][0], payload: rawEntries[i][1] });
            }
        }

        for (i = 0; i < entries.length; i++) {
            item = entries[i] || {};
            payload = item.payload || item;
            itemOrigins = normalizeOriginEntries(
                item.originUrls,
                item.originUrl,
                item.origin,
                item.url,
                payload.originUrls,
                payload.originUrl,
                payload.origin,
                payload.url
            );

            abArr = getArrayCI(payload, "abTest", "abTests", "abtest", "abtests");
            redArr = getArrayCI(payload, "redirection", "redirects", "redirect");

            abtests = [];
            for (j = 0; j < abArr.length; j++) {
                t = abArr[j] || {};
                id = String(pick(t.id, t.testId, t.uuid, Math.random().toString(36).slice(2)));
                name = pick(t.name, t.title, "test_" + id);
                startTime =
                    toISODate(pick(t.startTime, t.start, t.schedule && t.schedule.start)) ||
                    new Date(0).toISOString();
                endTime =
                    toISODate(pick(t.endTime, t.end, t.schedule && t.schedule.end)) ||
                    new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString();

                origins = normalizeOriginEntries(
                    t.originUrls,
                    t.originUrl,
                    t.origins,
                    t.origin,
                    itemOrigins
                );
                if (origins.length === 0) continue;

                variants = [];
                rawVariants = [].concat(t.alternates || []).concat(t.variants || []);
                for (k = 0; k < rawVariants.length; k++) {
                    var variant = rawVariants[k];
                    var variantUrl = variant && (variant.url || variant.href || variant.link);
                    if (!variantUrl) continue;
                    variants.push({
                        url: variantUrl,
                        weight: Number(pick(variant.weight, variant.ratio, 1)) || 1,
                    });
                }

                for (k = 0; k < origins.length; k++) {
                    origin = origins[k];
                    abtests.push({
                        id: id,
                        name: name,
                        startTime: startTime,
                        endTime: endTime,
                        origin: origin,
                        origins: origins,
                        alternates: variants,
                        queryConditions: Array.isArray(t.queryConditions) ? t.queryConditions : [],
                        useCondition: !!t.useCondition,
                        conditions: Array.isArray(t.conditions) ? t.conditions : [],
                    });
                }
            }

            redirects = [];
            for (j = 0; j < redArr.length; j++) {
                var alts = [];
                var rawAlts;
                var altEntry;
                var altUrl;

                r = redArr[j] || {};
                id = String(pick(r.id, r.uuid, Math.random().toString(36).slice(2)));
                name = pick(r.name, r.title, "redirect_" + id);
                startTime = toISODate(pick(r.startTime, r.start)) || new Date(0).toISOString();
                endTime =
                    toISODate(pick(r.endTime, r.end)) ||
                    new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString();

                if (typeof r.alternate === "string" && r.alternate.trim()) {
                    alts = [{ url: r.alternate }];
                } else {
                    rawAlts = pick(r.alternates, r.urls, r.targets, r.destinations, r.to, []);
                    if (!Array.isArray(rawAlts)) rawAlts = [rawAlts];
                    for (k = 0; k < rawAlts.length; k++) {
                        altEntry = rawAlts[k];
                        if (typeof altEntry === "string") {
                            alts.push({ url: altEntry });
                            continue;
                        }
                        altUrl = getAlternateEntryUrl(altEntry);
                        if (altUrl) alts.push({ url: altUrl });
                    }
                }
                if (alts.length === 0) continue;

                origins = normalizeOriginEntries(
                    r.originUrls,
                    r.originUrl,
                    r.origins,
                    r.origin,
                    itemOrigins
                );
                if (origins.length === 0) continue;

                for (k = 0; k < origins.length; k++) {
                    origin = origins[k];
                    redirects.push({
                        id: id,
                        name: name,
                        startTime: startTime,
                        endTime: endTime,
                        origin: origin,
                        origins: origins,
                        alternates: alts,
                        queryConditions: Array.isArray(r.queryConditions) ? r.queryConditions : [],
                        useCondition: !!r.useCondition,
                        conditions: Array.isArray(r.conditions) ? r.conditions : [],
                    });
                }
            }

            for (j = 0; j < abtests.length; j++) {
                originKey = getPageKeyFromURL(abtests[j].origin.url);
                if (!originKey) continue;
                if (!out[originKey]) out[originKey] = { abtests: [], redirects: [] };
                out[originKey].abtests.push(abtests[j]);
            }

            for (j = 0; j < redirects.length; j++) {
                redirect = redirects[j];
                originKey = getPageKeyFromURL(redirect.origin.url);
                if (!originKey) continue;
                if (!out[originKey]) out[originKey] = { abtests: [], redirects: [] };
                out[originKey].redirects.push(redirect);
            }
        }

        return out;
    }

    function clearOtherLandings(keepId) {
        var keysToRemove = [];
        var i;
        var key;
        for (i = 0; i < sessionStorage.length; i++) {
            key = sessionStorage.key(i);
            if (startsWith(key, "ab_test_landed_") && key !== "ab_test_landed_" + keepId) {
                keysToRemove.push(key);
            }
        }
        for (i = 0; i < keysToRemove.length; i++) {
            sessionStorage.removeItem(keysToRemove[i]);
        }
    }

    function clearTrackingInfo() {
        delete window.abTestTrackedSafe;
        sessionStorage.removeItem(TRACKING_INFO_KEY);
    }

    function setTrackingInfo(abInfo) {
        if (!abInfo || !abInfo.id) return;
        window.abTestTrackedSafe = abInfo;
        sessionStorage.setItem(TRACKING_INFO_KEY, JSON.stringify(abInfo));
    }

    function markLandingSession(abInfo) {
        var flagKey;
        if (!abInfo || !abInfo.id) return;
        flagKey = "ab_test_landed_" + abInfo.id;
        console.log("[AB landing mark]", {
            currentUrl: window.location.href,
            flagKey: flagKey,
            abInfo: abInfo,
        });
        if (!sessionStorage.getItem(flagKey)) {
            sessionStorage.setItem(flagKey, "true");
            clearOtherLandings(abInfo.id);
        }
        setTrackingInfo(abInfo);
    }

    // === GTM 커스텀 이벤트 헬퍼 ===
    function pushDL(evt, abInfo) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: evt,
                ab_id: String(abInfo.id),
                ab_name: abInfo.name,
                ab_group: abInfo.group,
                ab_url: abInfo.url,
                ab_page_key: getPageKeyFromURL(location.href),
                ab_ts: Date.now(),
            });
        } catch (e) {}
    }

    function sendABEvent(abInfo) {
        try {
            if (!abInfo || !abInfo.id || !abInfo.name || !abInfo.group) return;

            var sentKey = PA_SENT_PREFIX + abInfo.id;
            if (sessionStorage.getItem(sentKey) === "true") return;

            function trySend(attempt) {
                if (typeof attempt === "undefined") attempt = 0;

                if (typeof window.pa === "function") {
                    window.pa("send", "Event", {
                        eventNumber: eloEventNum,
                        abTest: {
                            id: String(abInfo.id),
                            name: abInfo.name,
                            group: abInfo.group,
                        },
                    });
                    sessionStorage.setItem(sentKey, "true");
                    console.log("[AB pa sent]", {
                        currentUrl: window.location.href,
                        abInfo: abInfo,
                        attempt: attempt,
                    });
                    return;
                }

                if (attempt >= 10) {
                    console.warn("[AB pa missing]", {
                        currentUrl: window.location.href,
                        abInfo: abInfo,
                        attempt: attempt,
                    });
                    return;
                }

                setTimeout(function () {
                    trySend(attempt + 1);
                }, 300);
            }

            trySend();
        } catch (e) {
            console.warn("[AB pa send failed]", (e && e.message) || e);
        }
    }

    function markRedirectDone(id) {
        sessionStorage.setItem("ab_redirect_done_" + id, "true");
    }

    function wasRedirectDone(id) {
        return sessionStorage.getItem("ab_redirect_done_" + id) === "true";
    }

    function handleConfig(raw) {
        var byOrigin;
        var currentKey;
        var matchedOriginKey;
        var cfg;
        var aliveIds = [];
        var aliveIdLookup = {};
        var abTestsById = {};
        var values;
        var i;
        var j;
        var originKeys;
        var tests;
        var id;
        var cookieParts;
        var name;

        console.log(raw);
        saveSessionEntry();

        byOrigin = normalizeByOrigin(raw);
        currentKey = getPageKeyFromURL(window.location.href);
        originKeys = Object.keys(byOrigin);
        for (i = 0; i < originKeys.length; i++) {
            if (currentKey && (includes(originKeys[i], currentKey) || includes(currentKey, originKeys[i]))) {
                matchedOriginKey = originKeys[i];
                break;
            }
        }
        cfg = matchedOriginKey ? byOrigin[matchedOriginKey] : undefined;

        values = objectValues(byOrigin);
        for (i = 0; i < values.length; i++) {
            tests = values[i].abtests || [];
            for (j = 0; j < tests.length; j++) {
                id = String((tests[j] && tests[j].id) || "");
                if (!id) continue;
                if (!hasOwnProp(aliveIdLookup, id)) {
                    aliveIdLookup[id] = true;
                    aliveIds.push(id);
                }
                if (!abTestsById[id]) abTestsById[id] = tests[j];
            }
        }

        cookieParts = document.cookie.split(";");
        for (i = 0; i < cookieParts.length; i++) {
            name = cookieParts[i].trim().split("=")[0];
            if (startsWith(name, TEST_COOKIE_PREFIX)) {
                id = name.replace(TEST_COOKIE_PREFIX, "");
                if (!hasOwnProp(aliveIdLookup, id)) deleteCookie(name);
            }
        }

        function syncTrackedLandingFromCookie() {
            var i;
            var id;
            var existing;
            var abInfo;
            var test;
            var normalized;

            for (i = 0; i < aliveIds.length; i++) {
                id = aliveIds[i];
                existing = getCookie(TEST_COOKIE_PREFIX + id);
                if (!existing) continue;
                try {
                    abInfo = JSON.parse(existing);
                    test = abTestsById[String((abInfo && abInfo.id) || id)];
                    if (test) {
                        normalized = normalizeABInfoForTest(abInfo, test);
                        if (JSON.stringify(normalized) !== JSON.stringify(abInfo)) {
                            setCookie(
                                TEST_COOKIE_PREFIX + id,
                                JSON.stringify(normalized),
                                new Date(normalized.expired || test.endTime)
                            );
                        }
                        abInfo = normalized;
                    }
                    if (!isSamePageURL(window.location.href, abInfo.url)) continue;
                    window.abTest = abInfo;
                    console.log("[AB landing fired: cookie-sync]", {
                        currentUrl: window.location.href,
                        abInfo: abInfo,
                    });
                    markLandingSession(abInfo);
                    pushDL("ab_landing", abInfo);
                    sendABEvent(abInfo);
                    return true;
                } catch (e) {
                    continue;
                }
            }
            return false;
        }

        if (!cfg) {
            syncTrackedLandingFromCookie();
            return;
        }

        if (Array.isArray(cfg.abtests)) {
            var now = new Date();
            var activeABs = [];
            var test;
            var baseTotal;
            var altSum;
            var m;
            var alternates;
            var cookieKey;
            var endDate;
            var existing;
            var abInfo;
            var isSame;
            var originCandidate;
            var candidates;
            var selected;
            var group;
            var normalized;

            for (i = 0; i < cfg.abtests.length; i++) {
                test = cfg.abtests[i];
                if (
                    isActiveNow(test, now) &&
                    matchesQueryConditions(test) &&
                    isSamePageURL(window.location.href, getTestOriginURL(test))
                ) {
                    activeABs.push(test);
                }
            }

            if (activeABs.length > 0) {
                for (i = 0; i < activeABs.length; i++) {
                    test = activeABs[i];
                    if (!matchesUTMConditions(test)) continue;

                    baseTotal = 100;
                    altSum = 0;
                    alternates = Array.isArray(test.alternates) ? test.alternates : [];
                    for (m = 0; m < alternates.length; m++) {
                        altSum += Number((alternates[m] && alternates[m].weight) || 0);
                    }

                    if (!test.origin) test.origin = { url: "" };
                    test.origin.weight = Math.max(0, baseTotal - altSum);
                    console.log("[AB weight 조정]", {
                        originWeight: test.origin.weight,
                        altWeights: (test.alternates || []).map(function (a) {
                            return a.weight;
                        }),
                    });

                    cookieKey = TEST_COOKIE_PREFIX + test.id;
                    endDate = new Date(test.endTime);
                    existing = getCookie(cookieKey);
                    if (existing) {
                        try {
                            abInfo = JSON.parse(existing);
                            normalized = normalizeABInfoForTest(abInfo, test);
                            if (JSON.stringify(normalized) !== JSON.stringify(abInfo)) {
                                setCookie(cookieKey, JSON.stringify(normalized), endDate);
                            }
                            abInfo = normalized;
                            window.abTest = abInfo;
                            isSame = isSamePageURL(window.location.href, abInfo.url);
                            console.log("[AB redirect check: existing]", {
                                currentUrl: window.location.href,
                                targetUrl: abInfo.url,
                                currentSearch: window.location.search,
                                targetKey: getPageKeyFromURL(abInfo.url, {
                                    stripTracking: false,
                                }),
                                currentKey: getPageKeyFromURL(window.location.href, {
                                    stripTracking: false,
                                }),
                                isSame: isSame,
                                abInfo: abInfo,
                            });
                            if (isSame) {
                                console.log("[AB landing fired: existing]", {
                                    currentUrl: window.location.href,
                                    abInfo: abInfo,
                                });
                                markLandingSession(abInfo);
                                pushDL("ab_landing", abInfo);
                                sendABEvent(abInfo);
                            }
                            if (!isSame) location.replace(abInfo.url);
                            return;
                        } catch (e) {}
                    }

                    originCandidate = cloneObject(test.origin || {});
                    originCandidate.url = getTestOriginURL(test);
                    candidates = [originCandidate].concat(test.alternates || []);
                    selected = candidates.length === 1 ? candidates[0] : weightedRandom(candidates);
                    if (!selected || !selected.url) continue;

                    group = determineGroupName(selected.url, test);
                    abInfo = {
                        id: String(test.id),
                        name: test.name,
                        group: group,
                        ratio: String(
                            selected.weight !== undefined && selected.weight !== null
                                ? selected.weight
                                : 1
                        ),
                        url: selected.url,
                        expired: endDate.toISOString(),
                    };

                    setCookie(cookieKey, JSON.stringify(abInfo), endDate);
                    window.abTest = abInfo;

                    isSame = isSamePageURL(window.location.href, selected.url);
                    console.log("[AB redirect check: selected]", {
                        currentUrl: window.location.href,
                        targetUrl: selected.url,
                        currentSearch: window.location.search,
                        targetKey: getPageKeyFromURL(selected.url, {
                            stripTracking: false,
                        }),
                        currentKey: getPageKeyFromURL(window.location.href, {
                            stripTracking: false,
                        }),
                        isSame: isSame,
                        selected: selected,
                        abInfo: abInfo,
                    });
                    if (isSame) {
                        console.log("[AB landing fired: selected]", {
                            currentUrl: window.location.href,
                            abInfo: abInfo,
                        });
                        markLandingSession(abInfo);
                        pushDL("ab_landing", abInfo);
                        sendABEvent(abInfo);
                    }
                    if (!isSame) location.replace(selected.url);
                    return;
                }
            }
        }

        if (syncTrackedLandingFromCookie()) {
            return;
        }

        if (Array.isArray(cfg.redirects) && cfg.redirects.length > 0) {
            var now = new Date();
            var r;
            var target;
            var alternates;

            for (i = 0; i < cfg.redirects.length; i++) {
                r = cfg.redirects[i];
                if (!isActiveNow(r, now)) continue;
                if (wasRedirectDone(r.id)) continue;
                if (!matchesQueryConditions(r)) continue;
                if (!matchesUTMConditions(r)) continue;

                target = null;
                alternates = r.alternates || [];
                for (j = 0; j < alternates.length; j++) {
                    if (alternates[j] && alternates[j].url && !isSamePageURL(window.location.href, alternates[j].url)) {
                        target = alternates[j];
                        break;
                    }
                }

                if (target && target.url) {
                    markRedirectDone(r.id);
                    location.replace(target.url);
                    return;
                }
            }
        }
    }

    try {
        clearTrackingInfo();
        fetch(
            "https://landingoptcdnprd.edisonoptimizer.com/andarus/landings2.json?ts=" +
                Date.now(),
            { method: "GET", cache: "no-store" }
        )
            .then(function (response) {
                if (!response.ok) throw new Error("AB 테스트 설정 불러오기 실패");
                return response.json();
            })
            .then(function (raw) {
                handleConfig(raw);
            })
            .catch(function (err) {
                console.warn("A/B 테스트 처리 실패:", (err && err.message) || err);
            });
    } catch (err) {
        console.warn("A/B 테스트 처리 실패:", (err && err.message) || err);
    }
})();
